<template>
  <nav aria-label="Tables pagination">
    <ul class="pagination" :class="sizeClass" style="margin: 0">
      <li v-if="showArrows" @click="changePage(currentPage - 1)">
        <span class="page-link">&laquo;</span>
      </li>
      <li
        v-for="(pageNumber, i) in range"
        :key="`page-${pageNumber + i}`"
        class="page-item"
        :class="{ active: pageNumber === currentPage }"
        @click="changePage(pageNumber)"
      >
        <a class="page-link" href="javascript:void(0);">{{ pageNumber }}</a>
      </li>
      <li v-if="showArrows" @click="changePage(currentPage + 1)"><span class="page-link">&raquo;</span></li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    total: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    showArrows: {
      type: Boolean
    },
    delta: {
      type: Number,
      default: 2 // should be greater than 1
    },
    size: {
      type: String,
      default: ""
    }
  },
  computed: {
    sizeClass() {
      return {
        "pagination-lg": this.size === "lg",
        "pagination-sm": this.size === "sm"
      };
    },
    range() {
      let pages = [];
      let range = [];
      let start = this.currentPage - this.delta <= 1 ? 0 : this.currentPage - this.delta;
      let end = this.currentPage + this.delta > this.total ? this.total : this.currentPage + this.delta - 1;
      for (let i = 1; i <= this.total; i++) {
        pages.push(i);
      }
      range = pages.slice(start, end);

      if (range[0] !== 1) range.unshift(1, "...");
      if (range[range.length - 1] !== this.total)
        this.currentPage + this.delta === this.total ? range.push(this.total) : range.push("...", this.total);

      return range;
    }
  },
  methods: {
    changePage(pageNumber) {
      if (pageNumber < 1 || pageNumber > this.total || pageNumber === this.currentPage || pageNumber === "...") return;
      this.$emit("pageChanged", pageNumber);
    }
  }
};
</script>

<style scoped>
.pagination span {
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none;
}

.pagination-lg .page-link {
  padding: 1rem 1.75rem;
  font-size: 1.5rem;
  line-height: 1.5;
}

.pagination-sm .page-link {
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
}
</style>
